import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import emailjs from '@emailjs/browser';
emailjs.init('p60i6b7rnE2_kRckK');

// Importing styles
import 'bootstrap/dist/css/bootstrap.css';
import './assets/tray.css';

// Setting up jQuery
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
require('bootstrap');

// Setting up WebFont
import WebFont from 'webfontloader';
WebFont.load({
  google: {
    families: ['Rajdhani:400,500,600,700']
  }
});

// Create and mount the Vue application
const app = createApp(App);
app.use(router);
app.mount('#app');